export default __webpack_public_path__ + "images/28cbdb65bfd6e4f7131a87e0db65e21b.png";